// держать в соответствии с src/node/repositories/offer-card/entities/extended_data/ExtendedDataSchema.ts

export enum EActionType {
  /** Смотреть заявку на бронирование **/
  'BookingRequestView' = 'bookingRequestView',
  /** Возможность написать в чат **/
  'Chat' = 'chat',
  /** Возможность связаться напрямую **/
  'Contact' = 'contact',
  /** Бронирование **/
  'OtaBooking' = 'otaBooking',
  /** Проверка дат **/
  'OtaCheckDates' = 'otaCheckDates',
  /** Забронировать партнёрский объект **/
  'PartnerBooking' = 'partnerBooking',
  /** Проверка дат у партнёрского объекта **/
  'PartnerCheckDates' = 'partnerCheckDates',
}

export enum EOfferLabels {
  /** Мгновенное бронирование **/
  'InstantBooking' = 'instantBooking',
}
